import { DollarSign } from 'lucide-react';
import { StatCard, Card } from '@/components/Card';
import { useApi } from '@/hooks/useApi';

interface CompSummary {
  employee_count: number;
  with_compensation: number;
  total_annual_payroll: number;
  average_salary: number;
  median_salary: number;
  by_department: Record<string, { count: number; avg_salary: number; total: number }>;
}

export function CompensationPage() {
  const { data, loading } = useApi<CompSummary>('compensation/summary');

  if (loading) return <div className="text-muted-foreground">Loading...</div>;
  if (!data) return <div className="text-muted-foreground">No data</div>;

  const fmt = (n: number) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Total Payroll" value={fmt(data.total_annual_payroll)} icon={<DollarSign className="w-5 h-5" />} accent />
        <StatCard label="Average Salary" value={fmt(data.average_salary)} />
        <StatCard label="Median Salary" value={fmt(data.median_salary)} />
        <StatCard label="Employees w/ Comp" value={`${data.with_compensation}/${data.employee_count}`} />
      </div>

      <Card>
        <h3 className="text-sm font-medium text-foreground mb-4">Compensation by Department</h3>
        <div className="space-y-3">
          {Object.entries(data.by_department).map(([dept, info]) => (
            <div key={dept} className="flex items-center justify-between py-2 border-b border-border/50 last:border-0">
              <div>
                <p className="text-sm text-foreground">{dept}</p>
                <p className="text-xs text-muted-foreground">{info.count} employees</p>
              </div>
              <div className="text-right">
                <p className="text-sm text-foreground">{fmt(info.avg_salary)}</p>
                <p className="text-xs text-muted-foreground">avg salary</p>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
